import React, { useState, useEffect } from "react";
import { DatePicker, Radio, Select } from "antd";
import ReportApi from "@api/report";
import Title from "@/components/Title";
import moment from "moment";
import Area from "@/components/twoarea";
import Analysisapi from "@/api/analysis";
import Ocharts from "./ochart.js";
import "./../style.scss";
import "./style.css";
const { RangePicker } = DatePicker;

export default ({ history }) => {
  const date = new Date();
  const Year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  var clock = Year + "-";
  var clock1 = Year + "-";
  if (month < 10) {
    clock += "0";
    clock1 += "0";
  }
  clock += month + "-";
  clock1 += month + "-";
  if (day < 10) {
    clock += "0";
    clock1 += "0";
  }
  clock += day + " ";
  clock1 += day + 1 + " ";
  const [consumptionData, setConsumptionData] = useState({
    data: [],
    label: "",
  });
  const [station, setStation] = useState([]);
  const [stationId, setStationId] = useState();
  const [defaultDate, setDefaultDate] = useState();
  const [searchParams, setSearchParams] = useState({
    queryTimeStartStr: clock + "00:00:00",
    queryTimeEndStr: clock1 + "23:59:59",
    reportType: 1,
    inOrOut: '',
    stationId: stationId,
  });
  const [lineType, setLineType] = useState(21); // 默认展示瞬时功率
  const [lineTypeList, setLineTypeList] = useState([]);
  const [dlDyList, setDlDyList] = useState([]);

  useEffect(() => {
    if (stationId) {
      selectDnbSurface();
    }
  }, [searchParams, lineType]);

  useEffect(() => {
    getStation();
    selectEnergyList();
    selectEnergyDlDyList();
  }, []);

  const selectEnergyList = () => {
    Analysisapi.selectEnergyList().then((res) => {
      if (res.status == 0 && res.data) {
        setLineTypeList(res.data);
        if(res.data.length > 0){
          setSearchParams({
            ...searchParams,
            inOrOut: res.data[0].id,
          })
        }
      }
    });
  }
  const selectEnergyDlDyList = () => {
    Analysisapi.selectEnergyDlDyList().then((res) => {
      if (res.status == 0 && res.data) {
        setDlDyList(res.data);
        if(res.data.length > 0){
          setLineType(res.data[0].id)
        }
      }
    });
  }

  const getStation = () => {
    Analysisapi.getStation().then((res) => {
      if (res.status == 0 && res.data) {
        setStation(res.data);
        const id = res.data[0] ? res.data[0].id : -1;
        setStationId(id);
        setSearchParams({ ...searchParams, stationId: id });
      }
    });
  };

  const getStationId = (id, tag) => {
    if (tag == 1) {
      setSearchParams({
        ...searchParams,
        stationId: id,
      });
      setStationId(id);
    }
  };

  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));

  const stationIds = userInfo.stationIds ? userInfo.stationIds.split(",") : [];
  //能耗量分析
  const selectDnbSurface = () => {
    const data = {
      ...searchParams,
      stationId: stationId,
      dutyUserStationIds: stationIds,
      type: lineType,
    };
    if (data.reportType == 1) {
      data.queryTimeEndStr =
        moment(new Date()).format("YYYY-MM-DD ") + "23:59:59";
    }
    ReportApi.selectDnbSurface(data).then((res) => {
      const info = lineTypeList.find((item) => item.value == lineType);
      if (res.status == 0 && res.data && res.data.length > 0) {
        setConsumptionData({
          data: res.data,
          label: info ? info.label : '',
        });
      } else {
        setConsumptionData({
          data: [],
          label: info ? info.label : '',
        });
      }
    });
  };

  const DateQuery = (obj, tag) => {
    if (tag == 1) {
      setDefaultDate(obj);
      const startTime = moment(obj[0]).format("YYYY-MM-DD") + " 00:00:00";
      const endTime = moment(obj[1]).format("YYYY-MM-DD") + " 23:59:59";
      setSearchParams({
        ...searchParams,
        queryTimeStartStr: startTime,
        queryTimeEndStr: endTime,
      });
    }
  };
  const slotQuery = (obj, tag) => {
    let firstDate = "";
    let endDate = "";
    if (month < 10) {
      firstDate = Year + "-" + "0" + month + "-01";
    } else {
      firstDate = Year + "-" + month + "-01";
    }
    let currentMonth = date.getMonth();
    let nextMonth = ++currentMonth;
    let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
    let oneDay = 1000 * 60 * 60 * 24;
    let lastTime = new Date(nextMonthFirstDay - oneDay);
    let cmonth = parseInt(lastTime.getMonth() + 1);
    let cday = lastTime.getDate();
    if (cmonth < 10) {
      cmonth = "0" + cmonth;
    }
    if (cday < 10) {
      cday = "0" + cday;
    }
    endDate = date.getFullYear() + "-" + cmonth + "-" + cday;
    const bstartTime = moment(firstDate).format("YYYY-MM-DD") + " 00:00:00";
    const bendTime = moment(endDate).format("YYYY-MM-DD") + " 23:59:59";

    let firstDay = new Date();
    firstDay.setDate(1);
    firstDay.setMonth(0);
    let lastDay = new Date();
    lastDay.setFullYear(lastDay.getFullYear() + 1);
    lastDay.setDate(31);
    lastDay.setMonth(-1);
    firstDay = moment(firstDay).format("YYYY-MM-DD") + " 00:00:00";
    lastDay = moment(lastDay).format("YYYY-MM-DD") + " 23:59:59";

    if (tag == 1) {
      setDefaultDate(null);
      if (obj.target.value == "day") {
        setSearchParams({
          ...searchParams,
          queryTimeStartStr: clock + "00:00:00",
          queryTimeEndStr: clock1 + "00:00:00",
          reportType: 1,
        });
      }
      if (obj.target.value == "month") {
        setSearchParams({
          ...searchParams,
          reportType: 2,
          queryTimeStartStr: bstartTime,
          queryTimeEndStr: bendTime,
        });
      }
      if (obj.target.value == "year") {
        setSearchParams({
          ...searchParams,
          reportType: 2,
          queryTimeStartStr: firstDay,
          queryTimeEndStr: lastDay,
        });
      }
    }
  };

  return (
    <div className="baseContent energy">
      <div className="column" style={{ position: "relative",height:'auto' }}>
        <Title title="能耗量分析"></Title>
        <div className="area">
          <span
            style={{
              position: "absolute",
              marginLeft: "18px",
              borderBottom: "1px solid #EEF0F3",
              padding: "11px 15px 12px 5px",
              zIndex: "999",
            }}
          >
            厂站:
          </span>
          <Area station={station} getStationId={(e) => getStationId(e, 1)} />
          <div className="solid"></div>
          <div className="tdate">
            时间：
            <RangePicker
              value={defaultDate}
              allowClear={false}
              onChange={(e) => {
                DateQuery(e, 1);
              }}
              style={{ width: "220px" }}
            />
          </div>
        </div>
        <Radio.Group
          onChange={(e) => {
            slotQuery(e, 1);
          }}
          className="button"
          style={{ position: "absolute", width: "200px" }}
        >
          <Radio.Button className="button-children" value="day">
            日
          </Radio.Button>
          <Radio.Button className="button-children" value="month">
            月
          </Radio.Button>
          <Radio.Button className="button-children" value="year">
            年
          </Radio.Button>
        </Radio.Group>
        <div style={{ paddingLeft: 30 }}>
          <span>能耗类型：</span>
          <Select
            placeholder="请选择能耗类型"
            value={searchParams.inOrOut || ''}
            style={{width: '180px'}}
            onChange={(e) => setSearchParams({ ...searchParams, inOrOut: e})}
          >
            {lineTypeList.map((item) => {
              return (
                <Select.Option value={item.id} key={item.id}>
                  {item.name}
                </Select.Option>
              );
            })}
          </Select>

          <span style={{marginLeft: '30px'}}>电流电压类型：</span>
          <Select
            placeholder="请选择电流电压类型"
            value={lineType}
            style={{width: '180px'}}
            onChange={(e) => setLineType(e)}
          >
            {dlDyList.map((item) => {
              return (
                <Select.Option value={item.id} key={item.id}>
                  {item.name}
                </Select.Option>
              );
            })}
          </Select>
        </div>
        <Ocharts consumptionData={consumptionData} />
      </div>
    </div>
  );
};
